import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "space-info"
};
var _hoisted_2 = {
  class: "space-info-body"
};
var _hoisted_3 = {
  class: "header"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  key: 1,
  class: "feature_box-top"
};
var _hoisted_6 = {
  style: {
    "width": "70px"
  }
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  key: 0,
  class: "dropdown"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  class: "eyes-container"
};
var _hoisted_11 = {
  class: "eyes user-id"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  key: 0,
  class: "eyes-menu"
};
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  class: "header-tab"
};
var _hoisted_16 = ["onClick"];
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  key: 0,
  class: "wrap"
};
import { reactive, ref, markRaw, onMounted, onUnmounted, nextTick } from 'vue';
import navLeft from '@/components/navLeft';
import Home from './spaceInfo/home/index.vue';
import Create from './spaceInfo/create/index.vue';
import Album from './spaceInfo/album/index.vue';
import Activity from './spaceInfo/activity/index.vue';
import UserInfoView from './spaceInfo/home/userInfoView.vue';
import BgImageDialog from './spaceInfo/home/ImageDialog.vue';
import { teacherSpace, scopeOfDisplay, interview } from '@/api/personalHomepage';
import { getStore } from '@/util/store';
import { isTeacher, isStudent } from '@/hooks/useGoOtherSpace.js';
import { MessagePlugin } from 'tdesign-vue-next';
import { useRoute, useRouter } from 'vue-router';
import WujieVue from 'wujie-vue3';
export default {
  __name: 'SpaceInfo',
  setup: function setup(__props) {
    var bus = WujieVue.bus;
    var storeData = getStore({
      name: 'userInfo'
    });
    // 添加对子组件的引用
    var userInfoViewRef = ref(null);
    var tabs = reactive([{
      name: '主页',
      component: markRaw(Home),
      icon: 'homePage'
    }, {
      name: '创作',
      component: markRaw(Create),
      icon: 'creation'
    }, {
      name: '相册',
      component: markRaw(Album),
      icon: 'album'
    }, {
      name: '活动',
      component: markRaw(Activity),
      icon: 'events'
    }]);
    var route = useRoute();
    var router = useRouter();
    var currentBanner = ref('');
    var clickRightValue = ref(1); // 0:游客 1:自己 2:公开

    var activeTab = ref(0); // 当前激活的tab
    var userInfo = ref({}); // 接口返回当前登录人的详情
    var IdPeople = ref(''); // 当前的人的id
    var namePeople = ref('');
    // 切换tab
    var changeActiveTab = function changeActiveTab(index) {
      activeTab.value = index;
    };

    // 公开范围
    var isDropdownOpen = ref(false);
    var options = ref([{
      content: '全部',
      value: '0'
    }, {
      content: '最近一个月',
      value: '1'
    }, {
      content: '本学期',
      value: '2'
    }, {
      content: '本学年',
      value: '3'
    }]);
    //  视角
    var optionsVisual = ref([{
      content: '我自己',
      value: 1
    }, {
      content: '公开',
      value: 2
    }]);
    var clickLeftValue = ref();
    var leftValue = ref(null);
    var without = ref(false);
    var viewingAngle = ref(optionsVisual.value[0].content);
    // 切换公开范围
    var clickLeft = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isDropdownOpen.value = false;
              clickLeftValue.value = val.content;
              _context.p = 1;
              _context.n = 2;
              return scopeOfDisplay(IdPeople.value, val.value);
            case 2:
              _context.n = 3;
              return initData();
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              MessagePlugin.error('操作失败');
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4]]);
      }));
      return function clickLeft(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    // 切换视角
    var isEyesDownOpen = ref(false);
    var clickRight = function clickRight(val) {
      isEyesDownOpen.value = false;
      clickRightValue.value = val.value;
      viewingAngle.value = val.content;
    };

    // 切换背景图
    var showBgImageDialog = ref(false);
    var handleMoreClick = function handleMoreClick() {
      showBgImageDialog.value = true;
    };
    var copyId = function copyId(id) {
      var text = document.createElement('textarea');
      text.value = id;
      document.body.appendChild(text);
      text.select();
      document.execCommand('copy');
      MessagePlugin.success('复制成功');
      text.remove();
    };
    var getUserInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var _yield$teacherSpace, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return teacherSpace(id);
            case 1:
              _yield$teacherSpace = _context2.v;
              data = _yield$teacherSpace.data;
              return _context2.a(2, data.data);
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              MessagePlugin.error('请求失败，请重试');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function getUserInfo(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 判断当前用户是否为登录用户
    var isLogin = ref(true);
    // 初始化数据
    var initData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var id,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              id = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : storeData.id;
              console.log(id, 'id');
              _context3.n = 1;
              return getUserInfo(id);
            case 1:
              userInfo.value = _context3.v;
              isLogin.value = storeData.id === userInfo.value.id;
              // 视角变化
              if (!isLogin.value) clickRightValue.value = 0;
              // 用户信息
              IdPeople.value = userInfo.value.id;
              namePeople.value = userInfo.value.name;
              clickLeftValue.value = options.value.find(function (item) {
                return item.value === userInfo.value.radius;
              }).content;
              leftValue.value = userInfo.value.radius;
              currentBanner.value = userInfo.value.backgroundImage;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function initData() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 增加一次访问记录
    var addVisit = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id, img) {
        var query, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              query = {
                visitorAvatar: userInfo.value.avatar || img
              };
              _context4.p = 1;
              _context4.n = 2;
              return interview(id, query);
            case 2:
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }));
      return function addVisit(_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    /**
     * 游客模式
     * @param val id 用户ID
     * @param num 0:游客 1:自己 2:公开
     * @param userType  类型 0:学生，1：老师
     */
    var changeId = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id, num, userType) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return addVisit(id);
            case 1:
              if (!(userType === '1')) {
                _context5.n = 5;
                break;
              }
              _context5.n = 2;
              return initData(id);
            case 2:
              IdPeople.value = id;
              clickRightValue.value = num;

              // 使用 nextTick 确保 DOM 更新后再调用
              _context5.n = 3;
              return nextTick();
            case 3:
              if (!userInfoViewRef.value) {
                _context5.n = 4;
                break;
              }
              _context5.n = 4;
              return userInfoViewRef.value.updateUserInfo(id);
            case 4:
              _context5.n = 6;
              break;
            case 5:
              // 学生个人主页
              router.push("/stuSpaceInfo?userId=".concat(id, "&hideLeftBar=false"));
            case 6:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function changeId(_x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      };
    }();
    // 返回自己
    var backHomeMe = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!isTeacher()) {
                _context6.n = 3;
                break;
              }
              // 教师个人主页
              router.push('/spaceInfo');
              clickRightValue.value = 1;
              viewingAngle.value = optionsVisual.value[0].content;
              isLogin.value = true;
              IdPeople.value = storeData.id;
              _context6.n = 1;
              return initData();
            case 1:
              if (!userInfoViewRef.value) {
                _context6.n = 2;
                break;
              }
              _context6.n = 2;
              return userInfoViewRef.value.updateUserInfo(IdPeople.value);
            case 2:
              _context6.n = 4;
              break;
            case 3:
              if (isStudent()) {
                // 学生个人主页
                router.push("/stuSpaceInfo?userId=".concat(storeData.id, "&hideLeftBar=false"));
              }
            case 4:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function backHomeMe() {
        return _ref6.apply(this, arguments);
      };
    }();
    // 切换背景图刷新
    var handleBgImageChange = function handleBgImageChange() {
      initData();
    };
    onMounted(function () {
      var params = route.query;
      params.hideLeftBar === 'false' ? without.value = false : without.value = true;
      if (params.userId) {
        addVisit(params.userId, storeData.avatar);
        initData(params.userId);
      } else {
        initData();
      }
      bus.$on('refreshTeacherSpacePage', function () {
        clickRightValue.value = 1;
        initData();
      });
    });
    onUnmounted(function () {
      bus.$off('refreshTeacherSpacePage');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createVNode(_unref(navLeft), null, null, 512), [[_vShow, without.value]]), _createElementVNode("div", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", {
        class: "header-info",
        style: _normalizeStyle({
          backgroundImage: "url(".concat(currentBanner.value, ")")
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass([clickRightValue.value === 2 ? 'feature_eyes' : 'feature_box'])
      }, [clickRightValue.value === 0 && without.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: backHomeMe
      }, [_createElementVNode("img", {
        src: require('@/assets/home/backHome.svg'),
        alt: ""
      }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), clickRightValue.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "text",
        style: {
          "width": "250px"
        },
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return isDropdownOpen.value = !isDropdownOpen.value;
        })
      }, [_cache[4] || (_cache[4] = _createTextVNode(" 公开展示的时间范围： ", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(clickLeftValue.value), 1), _createElementVNode("img", {
        src: require('@/assets/home/chevron-down.svg'),
        alt: ""
      }, null, 8, _hoisted_7)]), isDropdownOpen.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, function (option) {
        return _openBlock(), _createElementBlock("div", {
          key: option.value,
          class: _normalizeClass(["dropdown-item", {
            'dropdown-item-active': option.content === clickLeftValue.value
          }]),
          onClick: function onClick($event) {
            return clickLeft(option);
          }
        }, _toDisplayString(option.content), 11, _hoisted_9);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "text base-img",
        onClick: handleMoreClick
      }, "换背景图")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, "主页ID：" + _toDisplayString(userInfo.value.spaceAccount), 1), _createElementVNode("span", {
        style: {
          "margin-left": "8px"
        },
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return copyId(userInfo.value.spaceAccount);
        })
      }, "复制"), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "gay-tree"
      }, null, -1))]), clickRightValue.value !== 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "eyes",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return isEyesDownOpen.value = !isEyesDownOpen.value;
        })
      }, [_createTextVNode(" 视角：" + _toDisplayString(viewingAngle.value) + " ", 1), _createElementVNode("img", {
        src: require('@/assets/home/chevron-down.svg'),
        alt: ""
      }, null, 8, _hoisted_12)]), isEyesDownOpen.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsVisual.value, function (option) {
        return _openBlock(), _createElementBlock("div", {
          key: option.value,
          class: _normalizeClass(["eyes-item", {
            'eyes-item-active': option.content === viewingAngle.value
          }]),
          onClick: function onClick($event) {
            return clickRight(option);
          }
        }, _toDisplayString(option.content), 11, _hoisted_14);
      }), 128))])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])], 2), _createVNode(UserInfoView, {
        ref_key: "userInfoViewRef",
        ref: userInfoViewRef,
        "user-info": userInfo.value,
        "click-right-value": clickRightValue.value
      }, null, 8, ["user-info", "click-right-value"])], 4), _createElementVNode("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(['tab-item', activeTab.value === index && 'is-active']),
          key: index,
          onClick: function onClick($event) {
            return changeActiveTab(index);
          }
        }, [_createElementVNode("img", {
          src: require("@/assets/home/".concat(item.icon, ".svg"))
        }, null, 8, _hoisted_17), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 10, _hoisted_16);
      }), 128))])]), leftValue.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(), _createBlock(_resolveDynamicComponent(tabs[activeTab.value].component), {
        "click-left-value": leftValue.value,
        "click-right-value": clickRightValue.value,
        "name-people": namePeople.value,
        IdPeople: IdPeople.value,
        spaceInfo: userInfo.value,
        onChangeId: changeId,
        onChangeNav: changeActiveTab,
        without: without.value
      }, null, 40, ["click-left-value", "click-right-value", "name-people", "IdPeople", "spaceInfo", "without"]))])) : _createCommentVNode("", true)])]), _createVNode(BgImageDialog, {
        visible: showBgImageDialog.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return showBgImageDialog.value = $event;
        }),
        "store-data": _unref(storeData),
        "default-index": currentBanner.value,
        type: 1,
        onChange: handleBgImageChange
      }, null, 8, ["visible", "store-data", "default-index"])], 64);
    };
  }
};